define('viewModels/privileged/qm/AnnotationTypeResources',[], function () {
    'use strict';

    // these should match QMAnnotationType on the server
    var AnnotationTypeResources = {
        "keyword spot": {
            "iconClassName": "fa fa-microphone",
            "labelKey": "annotation.keywordTitle"
        },
        "pause": {
            "iconClassName": "fa fa-pause",
            "labelKey": "annotation.pauseTitle"
        },
        "securepause": {
            "iconClassName": "fa fa-pause",
            "labelKey": "annotation.securePauseTitle"
        },
        "hold": {
            "iconClassName": "fa fa-asterisk",
            "labelKey": "annotation.holdTitle"
        },
        "bookmark": {
            "iconClassName": "fa fa-bookmark",
            "labelKey": "annotation.bookmarkTitle"
        },
        "unknown": {
            "iconClassName": "fa fa-asterisk",
            "labelKey": "annotation.unknownTitle"
        }
    };

    return AnnotationTypeResources;
});

